import { defineMessages } from 'react-intl';

export const workingBlockMessages = defineMessages({
  thinkingFor: {
    id: '++q+2jg0LS',
    defaultMessage: 'Working for {duration}',
    description: 'Working block header while the agent is still working',
  },
  thoughtFor: {
    id: '7hFPvqTzI/',
    defaultMessage: 'Worked for {duration}',
    description: 'Working block header once the agent has finished working',
  },
  thinking: {
    id: '76K6lZK8LP',
    defaultMessage: 'Working',
    description:
      'Working block header while the agent works, when no duration is available',
  },
  thought: {
    id: 'KMNaXLF4eD',
    defaultMessage: 'Worked',
    description:
      'Working block header for finished work on a reloaded transcript, where no duration was measured',
  },
  workedThroughSteps: {
    id: 'qT66k9++5Q',
    defaultMessage:
      '{count, plural, one {Worked through # step} other {Worked through # steps}}',
    description: 'Working block header once work settles: how many steps the block holds',
  },
  workedThroughSources: {
    id: 'zPM/XY1vKL',
    defaultMessage:
      '{count, plural, one {Worked through # source} other {Worked through # sources}}',
    description:
      'Working block header once an Evidence-only block settles: how many sources it covered',
  },
  durationSeconds: {
    id: 'osce8ATDq8',
    defaultMessage: '{seconds}s',
    description: 'Elapsed working time under a minute',
  },
  durationMinutes: {
    id: '9JK0A7Pfiq',
    defaultMessage: '{minutes}m',
    description: 'Elapsed working time in whole minutes',
  },
  durationMinutesSeconds: {
    id: 'ZxBbnJ/cE8',
    defaultMessage: '{minutes}m {seconds}s',
    description: 'Elapsed working time in minutes and seconds',
  },
  evidenceBadge: {
    id: 'VCrBxD3vZO',
    defaultMessage: 'Evidence',
    description: 'Badge on a Working-block row the Evidence sub-agent ran',
  },
  evidenceSearches: {
    id: 'Zq2IglH+95',
    defaultMessage: '{count, plural, one {# search} other {# searches}}',
    description:
      'How many literature searches a running Evidence step has launched, after its label in the Working block',
  },
  evidenceSourcesFound: {
    id: 'Nr5IT7CafX',
    defaultMessage: '{count, plural, one {# source found} other {# sources found}}',
    description:
      'Working-block row that opens the list of sources an Evidence step found',
  },
  evidenceSourcesFoundWithLibrary: {
    id: 'ieek/FSmDW',
    defaultMessage:
      '{count, plural, one {# source found} other {# sources found}} · {library} from your library',
    description:
      "Working-block row that opens an Evidence step's sources when some are documents from the clinician's own library; count = web and partner sources, library = library documents",
  },
  evidenceLibrarySourcesFound: {
    id: 'N24938onqX',
    defaultMessage:
      '{count, plural, one {# source found in your library} other {# sources found in your library}}',
    description:
      "Working-block row that opens an Evidence step's sources when every one is a document from the clinician's own library",
  },
  evidenceYourLibrary: {
    id: 'BcrFH1EgCB',
    defaultMessage: 'Your library',
    description:
      "Where a source in an Evidence step's list comes from when it is a document in the clinician's own library, in place of a website's domain",
  },
});
